import React from 'react';

import DailyCard from './DailyCard.js';

const Cards = {
}

const Daily = (props) => {
    var CustomCard = Cards[props.pinnedItem.tag] || DailyCard;
    return <CustomCard {...props} />    
};

export default Daily;



// WEBPACK FOOTER //
// ./src/modules/challenges/customCards/Daily.js